import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuestionContainer;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import requiredIf from 'react-required-if';
import { v4 as uuid } from 'uuid';
import { jsx } from '@instructure/emotion';
import { RichContentInput, RCE_THREE_LINES_HEIGHT } from '@instructure/quiz-rce';
import { toErrors } from '../../../../../util/instUIMessages';
import PlainTextInput from '../PlainTextInput';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
var QuestionContainer = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuestionContainer = /*#__PURE__*/function (_Component) {
  function QuestionContainer() {
    var _this2;
    _classCallCheck(this, QuestionContainer);
    _this2 = _callSuper(this, QuestionContainer, arguments);
    _defineProperty(_this2, "handleRichContentChange", function (event, rceContent) {
      var editorContent = rceContent.editorContent;
      if (editorContent === void 0) {
        return;
      }
      _this2.updateDescription(editorContent);
    });
    _defineProperty(_this2, "handlePlainTextChange", function (event, content) {
      _this2.updateDescription(content);
    });
    _defineProperty(_this2, "handleRef", function (node) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      _this2.props.textareaRef.apply(_this2, [node].concat(args));
    });
    _defineProperty(_this2, "renderLabel", function () {
      return t('Question Stem');
    });
    _defineProperty(_this2, "renderPlaceHolder", function () {
      return _this2.props.placeholder || null;
    });
    _this2._defaultId = "QuestionContainer_".concat(uuid());
    _this2.state = {
      editorContent: _this2.props.itemBody
    };
    return _this2;
  }
  _inherits(QuestionContainer, _Component);
  return _createClass(QuestionContainer, [{
    key: "id",
    get: function get() {
      return this.props.textareaId || this._defaultId;
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(editorContent) {
      // check if the content actually changed before calling onDescriptionChange
      if (this.state.editorContent !== editorContent) {
        this.setState({
          editorContent: editorContent
        });
        this.props.onDescriptionChange(editorContent);
      }
    }
  }, {
    key: "renderRichContentInput",
    value: function renderRichContentInput() {
      return jsx(RichContentInput, {
        autoFocus: true,
        actsAsInput: true,
        defaultContent: this.props.itemBody,
        focusOnMount: this.props.focusOnMount,
        label: this.renderLabel(),
        plainTextLabel: t('Question Stem'),
        isRequired: true,
        messages: toErrors(this.props.stemErrors),
        onChange: this.handleRichContentChange,
        onKeyUp: this.handleRichContentChange,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        openImportModal: this.props.openImportModal,
        placeholder: this.renderPlaceHolder(),
        readOnly: this.props.readOnly || this.props.disabled,
        ref: this.handleRef,
        textareaId: this.id,
        height: RCE_THREE_LINES_HEIGHT
      });
    }
  }, {
    key: "renderPlainTextInput",
    value: function renderPlainTextInput() {
      return jsx(PlainTextInput, {
        defaultValue: this.props.itemBody,
        disabled: this.props.disabled,
        focusOnMount: this.props.focusOnMount,
        label: this.renderLabel(),
        required: true,
        messages: toErrors(this.props.stemErrors),
        onChange: this.handlePlainTextChange,
        placeholder: this.renderPlaceHolder(),
        textareaRef: this.handleRef
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.question
      }, jsx("div", {
        css: this.props.styles.stem,
        "data-automation": "sdk-question-stem"
      }, this.props.enableRichContentEditor ? this.renderRichContentInput() : this.renderPlainTextInput()), this.props.children);
    }
  }]);
}(Component), _defineProperty(_QuestionContainer, "displayName", 'QuestionContainer'), _defineProperty(_QuestionContainer, "componentId", "Quizzes".concat(_QuestionContainer.displayName)), _defineProperty(_QuestionContainer, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.array.isRequired]),
  disabled: PropTypes.bool,
  enableRichContentEditor: PropTypes.bool,
  focusOnMount: PropTypes.bool,
  itemBody: PropTypes.string,
  onDescriptionChange: PropTypes.func.isRequired,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  openImportModal: requiredIf(PropTypes.func, function (props) {
    return props.enableRichContentEditor;
  }),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  stemErrors: PropTypes.array,
  textareaId: PropTypes.string,
  textareaRef: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_QuestionContainer, "defaultProps", {
  disabled: false,
  enableRichContentEditor: true,
  focusOnMount: false,
  itemBody: '',
  placeholder: null,
  readOnly: false,
  textareaRef: Function.prototype,
  children: void 0,
  onModalClose: void 0,
  onModalOpen: void 0,
  openImportModal: void 0,
  stemErrors: void 0,
  textareaId: void 0
}), _QuestionContainer)) || _class);
export { QuestionContainer as default };